import { AppConfig } from 'config/types';
import IconETHLogo from 'assets/logos/ethlogo.svg';
import { ONE_HOUR_IN_MS } from 'utils/time';

const addresses = {
  ETH: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  WETH: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
  BNT: '0x1F573D6Fb3F13d689FF844B4cE37794d79a7FF1C',
  ZERO: '0x0000000000000000000000000000000000000000',
  USDT: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
  USDC: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  DAI: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
  WBTC: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
  SHIB: '0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE',
  ENJ: '0xF629cBd94d3791C9250152BD8dfBDF380E2a3B9c',
  UNI: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
  LINK: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
  LDO: '0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32',
  APE: '0x4d224452801ACEd8B2F0aebE155379bb5D594381',
  GRT: '0xc944E90C64B2c07662A292be6244BDf05Cda44a7',
  AAVE: '0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9',
  CRV: '0xD533a949740bb3306d119CC777fa900bA034cd52',
};

const popularTokens = [
  '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
  '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
  '0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c',
  '0xdac17f958d2ee523a2206206994597c13d831ec7',
  '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
  '0x6b175474e89094c44da98b954eedeac495271d0f',
  '0x514910771af9ca656af840dff83e8264ecf986ca',
  '0x1f9840a85d5af5bf1d1762f925bdaddc4201f984',
  '0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE',
  '0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c',
  '0x5a98fcbea516cf06857215779fd812ca3bef1b32',
  '0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9',
  '0x4d224452801aced8b2f0aebe155379bb5d594381',
  '0xc944e90c64b2c07662a292be6244bdf05cda44a7',
  '0xD533a949740bb3306d119CC777fa900bA034cd52',
  '0x6982508145454ce325ddbe47a25d4ec3d2311933',
  '0xae7ab96520de3a18e5e111b5eaab095312d7fe84',
  '0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0',
  '0x57e114B691Db790C35207b2e685D4A43181e6061',
  '0xB8c77482e45F1F44dE1745F52C74426C631bDD52',
  '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
  '0x2af5d2ad76741191d15dfe7bf6ac92d4bd912ca3',
  '0x582d872a1b094fc48f5de31d3b73f2d9be47def1',
  '0xdC035D45d973E3EC169d2276DDab16f1e407384F',
  '0xcd5fe23c85820f7b72d0926fc9b05b43e359b7ee',
  '0x4c9edd5852cd905f086c759e8383e09bff1e68b3',
  '0x54D2252757e1672EEaD234D27B1270728fF90581',
  '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
  '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
  '0x75231f58b43240c9718dd58b4967c5114342a86c',
  '0x85f17cf997934a597031b2e18a9ab6ebd4b9f6a4',
  '0x7712c34205737192402172409a8f7ccef8aa2aec',
  '0x6a9DA2D710BB9B700acde7Cb81F10F1fF8C89041',
  '0xa0b73e1ff0b80914ab6fe0444e65848c4c34450b',
  '0xfaba6f8e4a5e8ab82f62fe7c39859fa577269be3',
  '0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD',
  '0xe66747a101bff2dba3697199dcce5b743b454759',
  '0x3c3a81e81dc49a522a592e7622a7e711c06bf354',
  '0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24',
  '0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85',
  '0x455e53CBB86018Ac2B8092FdCd39d8444aFFC3F6',
  '0x8236a87084f8b84306f72007f36f2618a5634494',
  '0x163f8c2467924be0ae7b5347228cabf260318753',
  '0xB50721BCf8d664c30412Cfbc6cf7a15145234ad1',
  '0x4a220e6096b25eadb88358cb44068a3248254675',
  '0x56072C95FAA701256059aa122697B133aDEd9279',
  '0xc5f0f7b66764F6ec8C8Dff7BA683102295E16409',
  '0xf5e11df1ebcf78b6b6d26e04ff19cd786a1e81dc',
  '0xC139190F447e929f090Edeb554D95AbB8b18aC1C',
  '0xe28b3B32B6c345A34Ff64674606124Dd5Aceca30',
  '0xae78736cd615f374d3085123a210448e74fc6393',
  '0x44ff8620b8cA30902395A7bD3F2407e1A091BF73',
  '0xa1290d69c65a6fe4df752f95823fae25cb99e5a7',
  '0xE0f63A424a4439cBE457D80E4f4b51aD25b2c56C',
  '0xbdf43ecadc5cef51b7d1772f722e40596bc1788b',
  '0xf57e7e7c23978c3caec3c3548e3d615c346e79ff',
  '0xd5f7838f5c461feff7fe49ea5ebaf7728bb0adfa',
  '0xf1c9acdc66974dfb6decb12aa385b9cd01190e38',
  '0xde4EE8057785A7e8e800Db58F9784845A5C2Cbd6',
  '0xbf5495Efe5DB9ce00f80364C8B423567e58d2110',
  '0x68749665ff8d2d112fa859aa293f07a622782f38',
  '0xE7ae30C03395D66F30A26C49c91edAe151747911',
  '0xcf0c122c6b73ff809c693db761e7baebe62b6a2e',
  '0x45804880De22913dAFE09f4980848ECE6EcbAf78',
  '0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206',
  '0x152649eA73beAb28c5b49B26eb48f7EAD6d4c898',
  '0x1b19c19393e2d034d8ff31ff34c81252fcbbee92',
  '0xc18360217d8f7ab5e7c516566761ea12ce7f9d72',
  '0xc669928185dbce49d2230cc9b0979be6dc797957',
  '0x3845badAde8e6dFF049820680d1F14bD3903a5d0',
  '0xf3527ef8de265eaa3716fb312c12847bfba66cef',
  '0x808507121b80c02388fad14726482e061b8da827',
  '0xd9d920aa40f578ab794426f5c90f6c731d159def',
  '0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5',
  '0xc71b5f631354be6853efe9c3ab6b9590f8302e81',
  '0x96F6eF951840721AdBF46Ac996b59E0235CB985C',
  '0x5c147e74d63b1d31aa3fd78eb229b65161983b2b',
  '0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2',
  '0x0f5d2fb29fb7d3cfee444a200298f468908cc942',
  '0xe6829d9a7ee3040e1276fa75293bde931859e8fa',
  '0x18084fba666a33d37592fa2633fd49a74dd93a88',
  '0x0000000000085d4780B73119b644AE5ecd22b376',
  '0xa2cd3d43c775978a96bdbf12d733d5a1ed94fb18',
  '0xbe0Ed4138121EcFC5c0E56B40517da27E6c5226B',
  '0xca14007eff0db1f8135f4c25b34de49ab0d42766',
  '0x643C4E15d7d62Ad0aBeC4a9BD4b001aA3Ef52d66',
  '0x3D7975EcCFc61a2102b08925CbBa0a4D4dBB6555',
  '0xf469fbd2abcd6b9de8e169d128226c0fc90a012e',
  '0x198d14f2ad9ce69e76ea330b374de4957c3f850a',
  '0xec53bf9167f50cdeb3ae105f56099aaab9061f83',
  '0x136471a34f6ef19fe571effc1ca711fdb8e49f2b',
  '0xc00e94cb662c3520282e6f5717214004a7f26888',
  '0x35fa164735182de50811e8e2e824cfb9b6118ac2',
  '0x58d97b57bb95320f9a05dc918aef65434969c2b2',
  '0x320623b8e4ff03373931769a31fc52a4e78b5d70',
  '0xbb0e17ef65f82ab018d8edd776e8dd940327b28b',
  '0x626e8036deb333b408be468f951bdb42433cbf18',
  '0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD',
  '0x467Bccd9d29f223BcE8043b84E8C8B282827790F',
  '0xA35b1B31Ce002FBF2058D22F30f95D405200A15b',
  '0xFe0c30065B384F05761f15d0CC899D4F9F9Cc0eB',
  '0x3073f7aaa4db83f95e9fff17424f71d4751a3073',
  '0x3506424f91fd33084466f402d5d97f05f8e3b4af',
  '0xBe9895146f7AF43049ca1c1AE358B0541Ea49704',
  '0x58b6a8a3302369daec383334672404ee733ab239',
  '0x657e8c867d8b37dcc18fa4caead9c45eb088c642',
  '0xb0ffa8000886e57f86dd5264b9582b2ad87b2b91',
  '0xff20817765cb7f73d4bde2e66e067e58d11095c2',
  '0x6810e776880c02933d47db1b9fc05908e5386b96',
  '0x62D0A8458eD7719FDAF978fe5929C6D342B0bFcE',
  '0x64aa3364f17a4d01c6f1751fd97c2bd3d7e7f1d5',
  '0x853d955acef822db058eb8505911ed77f175b99e',
  '0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0',
  '0x467719ad09025fcc6cf6f8311755809d45a5e5f3',
  '0x4c1746a800d224393fe2470c70a35717ed4ea5f1',
  '0xa3ee21c306a700e682abcdfe9baa6a08f3820419',
  '0x3593d125a4f7849a1b059e64f4517a86dd60c95d',
  '0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55',
  '0x111111111117dc0aa78b770fa6a738034120c302',
  '0x5afe3855358e112b5647b952709e6165e1c1eeee',
  '0xa35923162c49cf95e6bf26623385eb431ad920d3',
  '0xccf4429db6322d5c611ee964527d42e5d685dd6a',
  '0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b',
  '0xac3e018457b222d93114458476f3e3416abbe38f',
  '0x11eef04c884e24d9b7b4760e7476d06ddf797f36',
  '0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0',
  '0x12e2b8033420270db2f3b328e32370cb5b2ca134',
  '0x6985884C4392D348587B19cb9eAAf157F13271cd',
  '0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429',
  '0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f',
  '0xf944e35f95e819e752f3ccb5faf40957d311e8c5',
  '0x05f4a42e251f2d52b8ed15e9fedaacfcef1fad27',
  '0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f',
  '0xe72b141df173b999ae7c1adcbf60cc9833ce56a8',
  '0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110',
  '0xa0769f7A8fC65e47dE93797b4e21C073c117Fc80',
  '0xD11c452fc99cF405034ee446803b6F6c1F6d5ED8',
  '0x004e9c3ef86bc1ca1f0bb5c7662861ee93350568',
  '0x5283d291dbcf85356a21ba090e6db59121208b44',
  '0xe41d2489571d322189246dafa5ebde1f4699f498',
  '0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c',
  '0x0d8775f648430679a709e98d2b0cb6250d2887ef',
  '0x6fb3e0a217407efff7ca062d46c26e5d60a14d69',
  '0x8A60E489004Ca22d775C5F2c657598278d17D9c2',
  '0xa2e3356610840701bdf5611a53974510ae27e2e1',
  '0x64d0f55Cd8C7133a9D7102b13987235F486F2224',
  '0xaa7a9ca87d3694b5755f213b5d04094b8d0f0a6f',
  '0x4DC26fC5854e7648a064a4ABD590bBE71724C277',
  '0x9Ce84F6A69986a83d92C324df10bC8E64771030f',
  '0x69af81e73a73b40adf4f3d4223cd9b1ece623074',
  '0xf091867ec603a6628ed83d274e835539d82e9cc8',
  '0x15700b564ca08d9439c58ca5053166e8317aa138',
  '0xdef1ca1fb7fbcdc777520aa7f396b4e015f497ab',
  '0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6',
  '0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e',
  '0x812Ba41e071C7b7fA4EBcFB62dF5F45f6fA853Ee',
  '0x7ddc52c4de30e94be3a6a0a2b259b2850f421989',
  '0x6c6ee5e31d828de241282b9606c8e98ea48526e2',
  '0xd5cd84d6f044abe314ee7e414d37cae8773ef9d3',
  '0xbf2179859fc6d5bee9bf9158632dc51678a4100e',
  '0x081f67afa0ccf8c7b17540767bbe95df2ba8d97f',
  '0xb23d80f5fefcddaa212212f028021b41ded428cf',
  '0x8290333cef9e6d528dd5618fb97a76f268f3edd4',
  '0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E',
  '0x6f40d4a6237c257fff2db00fa0510deeecd303eb',
  '0xd7c49cee7e9188cca6ad8ff264c1da2e69d4cf3b',
  '0xd9fcd98c322942075a5c3860693e9f4f03aae07b',
  '0xCdF7028ceAB81fA0C6971208e83fa7872994beE5',
  '0x55296f69f40ea6d20e478533c15a6b08b654e758',
  '0xe3c408BD53c31C085a1746AF401A4042954ff740',
  '0x4691937a7508860f876c9c0a2a617e7d9e945d4b',
  '0xdb25f211ab05b1c97d595516f45794528a807ad8',
  '0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0',
  '0xDBB5Cf12408a3Ac17d668037Ce289f9eA75439D7',
  '0x046eee2cc3188071c02bfc1745a6b17c656e3f3d',
  '0xc96de26018a54d51c097160568752c4e3bd6c364',
  '0x9c7beba8f6ef6643abd725e45a4e8387ef260649',
  '0x6b3595068778dd592e39a122f4f5a5cf09c90fe2',
  '0xddb3422497e61e13543bea06989c0789117555c5',
  '0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7',
  '0x4ddc2d193948926d02f9b1fe9e1daa0718270ed5',
  '0x037a54aab062628c9bbae1fdb1583c195585fe41',
  '0x856c4Efb76C1D1AE02e20CEB03A2A6a08b0b8dC3',
  '0x744d70fdbe2ba4cf95131626614a1763df805b9e',
  '0x0bb217e40f8a5cb79adf04e1aab60e5abd0dfc1e',
  '0xf411903cbc70a74d22900a5de66a2dda66507255',
  '0x6e2a43be0b1d33b726f0ca3b8de60b3482b8b050',
  '0xd33526068d116ce69f19a9ee46f0bd304f21a51f',
  '0xc0041ef357b183448b235a8ea73ce4e4ec8c265f',
  '0x767fe9edc9e0df98e07454847909b5e959d7ca0e',
  '0x839e71613f9aa06e5701cf6de63e303616b0dde3',
  '0xbdc7c08592ee4aa51d06c27ee23d5087d65adbcd',
  '0x8ce9137d39326ad0cd6491fb5cc0cba0e089b6a9',
  '0x9e32b13ce7f2e80a01932b42553652e053d6ed8e',
  '0x3bE775B699fee916E7De117994358fF8F48e4569',
  '0x64Bc2cA1Be492bE7185FAA2c8835d9b824c8a194',
  '0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828',
  '0x1202F5C7b4B9E47a1A484E8B270be34dbbC75055',
  '0xdd3B11eF34cd511a2DA159034a05fcb94D806686',
  '0xcb1592591996765ec0efc1f92599a19767ee5ffa',
  '0x8f8221afbb33998d8584a2b05749ba73c37a938a',
  '0xbbbbca6a901c926f240b89eacb641d8aec7aeafd',
  '0xe4880249745eAc5F1eD9d8F7DF844792D560e750',
  '0x47e5c76f155083f1aee39578311a2a5faa938a82',
  '0x14feE680690900BA0ccCfC76AD70Fd1b95D10e16',
  '0x12652C6d93FDB6F4f37d48A8687783C782BB0d10',
  '0xed04915c23f00a313a544955524eb7dbd823143d',
  '0xba11d00c5f74255f56a5e366f4f77f5a186d7f55',
  '0x7a58c0be72be218b41c608b7fe7c5bb630736c71',
  '0x764a726d9ced0433a8d7643335919deb03a9a935',
  '0x5b7533812759b45c2b44c19e320ba2cd2681b542',
  '0xf951E335afb289353dc249e82926178EaC7DEd78',
  '0x5c5b196abe0d54485975d1ec29617d42d9198326',
  '0xfc82bb4ba86045af6f327323a46e80412b91b27d',
  '0xC4441c2BE5d8fA8126822B9929CA0b81Ea0DE38E',
  '0xD7EFB00d12C2c13131FD319336Fdf952525dA2af',
  '0x6c5bA91642F10282b576d91922Ae6448C9d52f4E',
  '0x0f359fd18bda75e9c49bc027e7da59a4b01bf32a',
  '0xFAe103DC9cf190eD75350761e95403b7b8aFa6c0',
  '0xc43c6bfeda065fe2c4c11765bf838789bd0bb5de',
  '0x986EE2B944c42D017F52Af21c4c69B84DBeA35d8',
  '0x8ed97a637a790be1feff5e888d43629dc05408f6',
  '0x8457CA5040ad67fdebbCC8EdCE889A335Bc0fbFB',
  '0x41e5560054824ea6b0732e656e3ad64e20e94e45',
  '0x712bd4beb54c6b958267d9db0259abdbb0bff606',
  '0x18aAA7115705e8be94bfFEBDE57Af9BFc265B998',
  '0xff56cc6b1e6ded347aa0b7676c85ab0b3d08b0fa',
  '0xa849eaae994fb86afa73382e9bd88c2b6b18dc71',
  '0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec',
  '0xEE2a03Aa6Dacf51C18679C516ad5283d8E7C2637',
  '0xc08Cd26474722cE93F4D0c34D16201461c10AA8C',
  '0xB528edBef013aff855ac3c50b381f253aF13b997',
  '0x0000000000095413afc295d19edeb1ad7b71c952',
  '0x595832f8fc6bf59c85c527fec3740a1b7a361269',
  '0x868fced65edbf0056c4163515dd840e9f287a4c3',
  '0xb131f4A55907B10d1F0A50d8ab8FA09EC342cd74',
  '0x0b38210ea11411557c13457D4dA7dC6ea731B88a',
  '0x090185f2135308bad17527004364ebcc2d37e5f6',
  '0x579cea1889991f68acc35ff5c3dd0621ff29b0c9',
  '0x0fd10b9899882a6f2fcb5c371e17e70fdee00c38',
  '0x6033f7f88332b8db6ad452b7c6d5bb643990ae3f',
  '0x17418038ecF73BA4026c4f428547BF099706F27B',
  '0x6dea81c8171d0ba574754ef6f8b412f2ed88c54d',
  '0xef4461891dfb3ac8572ccf7c794664a8dd927945',
  '0x44108f0223A3C3028F5Fe7AEC7f9bb2E66beF82F',
  '0x4737D9b4592B40d51e110b94c9C043c6654067Ae',
  '0x607F4C5BB672230e8672085532f7e901544a7375',
  '0xb98d4c97425d9908e66e53a6fdf673acca0be986',
  '0x8c9532a60e0e7c6bbd2b2c1303f63ace1c3e9811',
  '0x2a3bff78b79a009976eea096a51a948a3dc00e34',
  '0x38E68A37E401F7271568CecaAc63c6B1e19130B4',
  '0x5dc60C4D5e75D22588FA17fFEB90A63E535efCE0',
  '0x2dfF88A56767223A5529eA5960Da7A3F5f766406',
  '0x57b946008913b82e4df85f501cbaed910e58d26c',
  '0x8e870d67f660d95d5be530380d0ec0bd388289e1',
  '0x340d2bde5eb28c1eed91b2f790723e3b160613b7',
  '0xb683d83a532e2cb7dfa5275eed3698436371cc9f',
  '0x0f3a12b78fee11ee088e454a0547bdbc5a253a6d',
  '0x10dea67478c5f8c5e2d90e5e9b26dbe60c54d800',
  '0x2b66aade1e9c062ff411bd47c44e0ad696d43bd9',
  '0xa21Af1050F7B26e0cfF45ee51548254C41ED6b5c',
  '0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3',
  '0x8eD955a2b7d2C3a17a9d05dACa95E01818f8C11e',
  '0x8A2279d4A90B6fe1C4B30fa660cC9f926797bAA2',
  '0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096',
  '0xEeB4d8400AEefafC1B2953e0094134A887C76Bd8',
  '0x967da4048cD07aB37855c090aAF366e4ce1b9F48',
  '0x3597bfd533a99c9aa083587b074434e61eb0a258',
  '0x9d65ff81a3c488d585bbfb0bfe3c7707c7917f54',
  '0xdab396ccf3d84cf2d07c4454e10c8a6f5b008d2b',
  '0xa663b02cf0a4b149d2ad41910cb81e23e1c41c32',
  '0xba100000625a3754423978a60c9317c58a424e3d',
  '0x0501b9188436e35bb10f35998c40adc079003866',
  '0x1776e1f26f98b1a5df9cd347953a26dd3cb46671',
  '0x8881562783028F5c1BCB985d2283D5E170D88888',
  '0x8DE5B80a0C1B02Fe4976851D030B36122dbb8624',
  '0xd084b83c305dafd76ae3e1b4e1f1fe2ecccb3988',
  '0xcacd6fd266af91b8aed52accc382b4e165586e29',
  '0x32353A6C91143bfd6C7d363B546e62a9A2489A20',
  '0xfd418e42783382E86Ae91e445406600Ba144D162',
  '0x23d7Ff057c696fEE679c60cEf61Fee6614218f04',
  '0x085780639CC2cACd35E474e71f4d000e2405d8f6',
  '0xed35af169af46a02ee13b9d79eb57d6d68c1749e',
  '0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202',
  '0x4fabb145d64652a948d72533023f6e7a623c7c53',
  '0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25',
  '0x06B964d96f5dCF7Eae9d7C559B09EDCe244d4B8E',
  '0x675B68AA4d9c2d3BB3F0397048e62E6B7192079c',
  '0x2255718832bC9fD3bE1CaF75084F4803DA14FF01',
  '0x2be5e8c109e2197D077D13A82dAead6a9b3433C5',
  '0x91Af0fBB28ABA7E31403Cb457106Ce79397FD4E6',
  '0x491604c0FDF08347Dd1fa4Ee062a822A5DD06B5D',
  '0x226bb599a12c826476e3a771454697ea52e9e220',
  '0x2e44f3f609ff5aa4819b323fd74690f07c3607c4',
  '0xe76C6c83af64e4C60245D8C7dE953DF673a7A33D',
  '0x6b0b3a982b4634ac68dd83a4dbf02311ce324181',
  '0xccc8cb5229b0ac8069c51fd58367fd1e622afd97',
  '0x4c11249814f11b9346808179cf06e71ac328c1b5',
  '0xbafdabadcf19d0cfbbe0ab9c69cf050d86ff888c',
  '0x056fd409e1d7a124bd7017459dfea2f387b6d5cd',
  '0xea26c4ac16d4a5a106820bc8aee85fd0b7b2b664',
  '0x2Ca9242c1810029Efed539F1c60D68B63AD01BFc',
  '0x0d86883faf4ffd7aeb116390af37746f45b6f378',
  '0x0655977feb2f289a4ab78af67bab0d17aab84367',
  '0x9aab071b4129b083b01cb5a0cb513ce7eca26fa5',
  '0x5de8ab7e27f6e7a1fff3e5b337584aa43961beef',
  '0x96543ef8d2c75c26387c1a319ae69c0bee6f3fe7',
  '0x8248270620aa532e4d64316017be5e873e37cc09',
  '0x14778860E937f509e651192a90589dE711Fb88a9',
  '0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2',
  '0xaaaaaa20d9e0e2461697782ef11675f668207961',
  '0x560363bda52bc6a44ca6c8c9b4a5fadbda32fa60',
  '0xae12c5930881c53715b369cec7606b70d8eb229f',
  '0xba5bde662c17e2adff1075610382b9b691296350',
  '0x292fcdd1b104de5a00250febba9bc6a5092a0076',
  '0xe5b826ca2ca02f09c1725e9bd98d9a8874c30532',
  '0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419',
  '0x4c19596f5aaff459fa38b0f7ed92f11ae6543784',
  '0x4f9254c83eb525f9fcf346490bbb3ed28a81c667',
  '0x0c7D5ae016f806603CB1782bEa29AC69471CAb9c',
  '0xa9e8acf069c58aec8825542845fd754e41a9489a',
  '0x391cF4b21F557c935C7f670218Ef42C21bd8d686',
  '0x430EF9263E76DAE63c84292C3409D61c598E9682',
  '0xDA987c655ebC38C801DB64A8608bc1AA56Cd9a31',
  '0x178c820f862b14f316509ec36b13123da19a6054',
  '0xd31695a1d35e489252ce57b129fd4b1b05e6acac',
  '0x431ad2ff6a9c365805ebad47ee021148d6f7dbe0',
  '0xC08e7E23C235073C6807C2EFE7021304cb7c2815',
  '0x24d7ad9402717f429a81925fe7643b78918eda8b',
  '0xA0Ef786Bf476fE0810408CaBA05E536aC800ff86',
  '0xaaa9214f675316182eaa21c85f0ca99160cc3aaa',
  '0x43Dfc4159D86F3A37A5A4B3D4580b888ad7d4DDd',
  '0x76A0e27618462bDAC7a29104bdcfFf4E6BFCea2D',
  '0xba3335588d9403515223f109edc4eb7269a9ab5d',
  '0x41545f8b9472D758bB669ed8EaEEEcD7a9C4Ec29',
  '0xD101dCC414F310268c37eEb4cD376CcFA507F571',
  '0xDd66781D0E9a08D4FBb5eC7BAc80B691BE27F21D',
  '0x590f820444fa3638e022776752c5eef34e2f89a6',
  '0x0d438f3b5175bebc262bf23753c1e53d03432bde',
  '0xB0c7a3Ba49C7a6EaBa6cD4a96C55a1391070Ac9A',
  '0x85eee30c52b0b379b046fb0f85f4f3dc3009afec',
  '0x42bbfa2e77757c645eeaad1655e0911a7553efbc',
  '0x817bbdbc3e8a1204f3691d14bb44992841e3db35',
  '0x5f0e628b693018f639d10e4a4f59bd4d8b2b6b44',
  '0x8207c1ffc5b6804f6024322ccf34f29c3541ae26',
  '0x26aAd156Ba8eFA501b32B42Ffcdc8413F90e9C99',
  '0xac51066d7bec65dc4589368da368b212745d63e8',
  '0xde2f7766c8bf14ca67193128535e5c7454f8387c',
  '0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac',
  '0x419d0d8bdd9af5e606ae2232ed285aff190e711b',
  '0x9e46a38f5daabe8683e10793b06749eef7d733d1',
  '0xa43a7c62d56df036c187e1966c03e2799d8987ed',
  '0x57ab1ec28d129707052df4df418d58a2d46d5f51',
  '0x31c8eacbffdd875c74b94b077895bd78cf1e64a3',
  '0x0f2d719407fdbeff09d87557abb7232601fd9f29',
  '0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359',
  '0x584bC13c7D411c00c01A62e8019472dE68768430',
  '0x2eC37d45FCAE65D9787ECf71dc85a444968f6646',
  '0xfd409bc96d126bc8a56479d4c7672015d539f96c',
  '0x4d1C297d39C5c1277964D0E3f8Aa901493664530',
  '0x77777feddddffc19ff86db637967013e6c6a116c',
  '0x88909d489678dd17aa6d9609f89b0419bf78fd9a',
  '0xc56C7A0eAA804f854B536A5F3D5f49D2EC4B12b8',
  '0x79f05c263055ba20ee0e814acd117c20caa10e0c',
  '0xbe9F61555F50DD6167f2772e9CF7519790d96624',
  '0x1e053d89e08c24aa2ce5c5b4206744dc2d7bd8f5',
  '0x8143182a775C54578c8B7b3Ef77982498866945D',
  '0x81f8f0bb1cb2a06649e51913a151f0e7ef6fa321',
  '0x4575f41308EC1483f3d399aa9a2826d74Da13Deb',
  '0x1ffefd8036409cb6d652bd610de465933b226917',
  '0x39aa39c021dfbae8fac545936693ac917d5e7563',
  '0x49fb8ad7578148e17c3ef0c344ce23a66ed372c4',
  '0x2565ae0385659badcada1031db704442e1b69982',
  '0x4161725d019690a3e0de50f6be67b07a86a9fae1',
  '0xb3999f658c0391d94a37f7ff328f3fec942bcadc',
  '0x3429d03c6F7521AeC737a0BBF2E5ddcef2C3Ae31',
  '0xba50933c268f567bdc86e1ac131be072c6b0b71a',
  '0x5c8D0C48810FD37A0A824D074ee290E64f7A8Fa2',
  '0xb6ee9668771a79be7967ee29a63d4184f8097143',
  '0x80122c6a83c8202ea365233363d3f4837d13e888',
  '0xcccd1ba9f7acd6117834e0d28f25645decb1736a',
  '0x7448c7456a97769f6cd04f1e83a4a23ccdc46abd',
  '0x1a3496c18d558bd9c6c8f609e1b129f67ab08163',
  '0x940a2db1b7008b6c776d4faaca729d6d4a4aa551',
  '0x5e29CF3E3fEd4df50aCab95f8268e9ee26Ea36f2',
  '0x73d7c860998ca3c01ce8c808f5577d94d545d1b4',
  '0x80c62fe4487e1351b47ba49809ebd60ed085bf52',
  '0x53c8395465a84955c95159814461466053dedede',
  '0xd46ba6d942050d489dbd938a2c909a5d5039a161',
  '0x7ABc8A5768E6bE61A6c693a6e4EAcb5B60602C4D',
  '0x12bb890508c125661e03b09ec06e404bc9289040',
  '0xe1bad922f84b198a08292fb600319300ae32471b',
  '0xd26114cd6EE289AccF82350c8d8487fedB8A0C07',
  '0x77fba179c79de5b7653f68b5039af940ada60ce0',
  '0x4ec1b60b96193a64acae44778e51f7bff2007831',
  '0xcafe001067cdef266afb7eb5a286dcfd277f3de5',
  '0x8806926Ab68EB5a7b909DcAf6FdBe5d93271D6e2',
  '0x137dDB47Ee24EaA998a535Ab00378d6BFa84F893',
  '0xe9a95d175a5f4c9369f3b74222402eb1b837693b',
  '0x8ccedbAe4916b79da7F3F612EfB2EB93A2bFD6cF',
  '0x2781246fe707bb15cee3e5ea354e2154a2877b16',
  '0xa0d69e286b938e21cbf7e51d71f6a4c8918f482f',
  '0x2a9bDCFF37aB68B95A53435ADFd8892e86084F93',
  '0x865ec58b06bf6305b886793aa20a2da31d034e68',
  '0x628a3b2e302c7e896acc432d2d0dd22b6cb9bc88',
  '0x3B50805453023a91a8bf641e279401a0b23FA6F9',
  '0x888888848b652b3e3a0f34c96e00eec0f3a23f72',
  '0xE95A203B1a91a908F9B9CE46459d101078c2c3cb',
  '0x94314a14Df63779c99C0764a30e0CD22fA78fC0E',
  '0xfb5c6815ca3ac72ce9f5006869ae67f18bf77006',
  '0x1F57da732A77636D913C9a75d685B26CC85DCC3A',
  '0x0000000000c5dc95539589fbd24be07c6c14eca4',
  '0x4957805230831401CaaD5b690AA138143B711358',
  '0xa2120b9e674d3fc3875f415a7df52e382f141225',
  '0x9ce115f0341ae5dabc8b477b74e83db2018a6f42',
  '0x30d20208d987713f46dfd34ef128bb16c404d10f',
  '0x7d5121505149065b562c789a0145ed750e6e8cdd',
  '0x826180541412D574cf1336d22c0C0a287822678A',
  '0x0f51bb10119727a7e5ea3538074fb341f56b09ad',
  '0xb90b2a35c65dbc466b04240097ca756ad2005295',
  '0xac3211a5025414af2866ff09c23fc18bc97e79b1',
  '0x2aeAbde1aB736c59E9A19BeD67681869eEF39526',
  '0xd13c7342e1ef687c5ad21b27c2b65d772cab5c8c',
  '0xd1ba9BAC957322D6e8c07a160a3A8dA11A0d2867',
  '0x5026F006B85729a8b14553FAE6af249aD16c9aaB',
  '0x4274cD7277C7bb0806Bd5FE84b9aDAE466a8DA0a',
  '0xcb86c6a22cb56b6cf40cafedb06ba0df188a416e',
  '0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643',
  '0xec67005c4e498ec7f55e092bd1d35cbc47c91892',
  '0x1bbe973bef3a977fc51cbed703e8ffdefe001fed',
  '0xF8F173E20e15f3b6CB686FB64724D370689De083',
  '0x92d6c1e31e14520e676a687f0a93788b716beff5',
  '0xa1faa113cbe53436df28ff0aee54275c13b40975',
  '0x39d5313c3750140e5042887413ba8aa6145a9bd2',
  '0xa9d54f37ebb99f83b603cc95fc1a5f3907aaccfd',
  '0xfb7b4564402e5500db5bb6d63ae671302777c75a',
  '0xf5581dfefd8fb0e4aec526be659cfab1f8c781da',
  '0x33D0568941C0C64ff7e0FB4fbA0B11BD37deEd9f',
  '0x93a2db22b7c736b341c32ff666307f4a9ed910f5',
  '0x193f4A4a6ea24102F49b931DEeeb931f6E32405d',
];

export const commonConfig: AppConfig = {
  mode: 'development',
  appName: 'Carbon DeFi',
  appUrl: 'https://app.carbondefi.xyz',
  carbonApi: 'https://api.carbondefi.xyz/v1/',
  externalLinks: {
    analytics: 'http://analytics.carbondefi.xyz',
    simulatorRepo: 'https://github.com/bancorprotocol/carbon-simulator',
    duneDashboard: 'https://dune.com/bancor/carbon-by-bancor',
  },
  selectedConnectors: ['MetaMask', 'WalletConnect', 'Coinbase Wallet', 'Safe'],
  blockedConnectors: ['Tailwind', 'Compass Wallet', 'Seif'],
  walletConnectProjectId: 'f9d8863ab6c03f2293d7d56d7c0c0853',
  policiesLastUpdated: '18 April, 2023',
  network: {
    name: 'Ethereum Network',
    logoUrl: IconETHLogo,
    chainId: 1,
    blockExplorer: { name: 'Etherscan', url: 'https://etherscan.io' },
    rpc: {
      url: 'https://ethereum-rpc.publicnode.com',
    },
    defaultLimitedApproval: false,
    gasToken: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18,
      address: addresses.ETH,
      logoURI:
        '/tokens/ethereum/0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee.svg',
    },
  },
  sdk: {
    cacheTTL: ONE_HOUR_IN_MS,
  },
  defaultTokenPair: [addresses.ETH, addresses.USDC],
  popularPairs: [
    [addresses.ETH, addresses.USDC],
    [addresses.ETH, addresses.USDT],
    [addresses.ETH, addresses.DAI],
    [addresses.ETH, addresses.WBTC],
    [addresses.BNT, addresses.USDC],
    [addresses.BNT, addresses.USDT],
    [addresses.BNT, addresses.DAI],
    [addresses.BNT, addresses.ETH],
    [addresses.BNT, addresses.WBTC],
    [addresses.WBTC, addresses.USDC],
    [addresses.WBTC, addresses.USDT],
    [addresses.WBTC, addresses.DAI],
    [addresses.WBTC, addresses.ETH],
    [addresses.USDT, addresses.USDC],
    [addresses.USDC, addresses.USDT],
    [addresses.USDT, addresses.DAI],
    [addresses.USDC, addresses.DAI],
    [addresses.DAI, addresses.USDC],
    [addresses.DAI, addresses.USDT],
    [addresses.SHIB, addresses.USDT],
    [addresses.SHIB, addresses.USDC],
    [addresses.SHIB, addresses.DAI],
    [addresses.SHIB, addresses.ETH],
  ],
  popularTokens: {
    base: popularTokens,
    quote: popularTokens,
  },
  addresses: {
    tokens: addresses,
    carbon: {
      carbonController: '0xC537e898CD774e2dCBa3B14Ea6f34C93d5eA45e1',
      voucher: '0x3660F04B79751e31128f6378eAC70807e38f554E',
      batcher: '0x0199f3A6C4B192B9f9C3eBE31FBC535CdD4B7D4e',
    },
  },
  utils: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
      blockCreated: 14353601,
    },
    ensRegistry: {
      address: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
    },
    ensUniversalResolver: {
      address: '0xce01f8eee7E479C928F8919abD53E553a36CeF67',
      blockCreated: 19_258_213,
    },
  },
  tokenListOverride: [
    {
      name: 'Wrapped Ether',
      symbol: 'WETH',
      decimals: 18,
      address: addresses.WETH,
      logoURI:
        '/tokens/ethereum/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2.svg',
    },
  ],
  tokenLists: [
    // Bancor
    {
      uri: '/tokens/ethereum/list.json',
    },
    // CoinGecko
    {
      uri: 'https://tokens.coingecko.com/ethereum/all.json',
    },
  ],
  tenderly: {
    faucetTokens: [
      {
        donorAccount: '0x0a59649758aa4d66e25f08dd01271e891fe52199',
        tokenContract: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        decimals: 6,
        symbol: 'USDC',
      },
      {
        donorAccount: '0x5777d92f208679db4b9778590fa3cab3ac9e2168',
        tokenContract: '0x6b175474e89094c44da98b954eedeac495271d0f',
        decimals: 18,
        symbol: 'DAI',
      },
      {
        donorAccount: '0xF977814e90dA44bFA03b6295A0616a897441aceC',
        tokenContract: '0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c',
        decimals: 18,
        symbol: 'BNT',
      },
      {
        donorAccount: '0x4338545408d73b0e6135876f9ff691bb72f1c8d9',
        tokenContract: '0x15b0dD2c5Db529Ab870915ff498bEa6d20Fb6b96',
        decimals: 18,
        symbol: 'PARQ',
      },
      {
        donorAccount: '0xccF4429DB6322D5C611ee964527D42E5d685DD6a',
        tokenContract: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
        decimals: 8,
        symbol: 'WBTC',
      },
      {
        donorAccount: '0x480234599362dC7a76cd99D09738A626F6d77e5F',
        tokenContract: '0xB8c77482e45F1F44dE1745F52C74426C631bDD52',
        decimals: 18,
        symbol: 'BNB',
      },
      {
        donorAccount: '0x5e3ef299fddf15eaa0432e6e66473ace8c13d908',
        tokenContract: '0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0',
        decimals: 18,
        symbol: 'MATIC',
      },
      {
        donorAccount: '0x5a52e96bacdabb82fd05763e25335261b270efcb',
        tokenContract: '0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE',
        decimals: 18,
        symbol: 'SHIB',
      },
      {
        donorAccount: '0x4b4e140d1f131fdad6fb59c13af796fd194e4135',
        tokenContract: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
        decimals: 18,
        symbol: 'UNI',
      },
      {
        donorAccount: '0x0162Cd2BA40E23378Bf0FD41f919E1be075f025F',
        tokenContract: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
        decimals: 6,
        symbol: 'USDT',
      },
    ],
  },
  ui: {
    showSimulator: true,
    priceChart: 'native',
    useGradientBranding: true,
    tradeCount: false,
    currencyMenu: true,
    showTerms: true,
    showPrivacy: true,
    showCart: true,
  },
};
